import React from 'react';

const SkillBadge = ({ skill }) => {
    return (
        <span className='inline-block bg-green-600 text-primary-400 px-2 py-1 rounded-full border-2 ml-2 hover:bg-green-700 select-none'>
            {skill}
        </span>
    );
};

export default SkillBadge;
